import { render, staticRenderFns } from "./SelectDepartmentView.vue?vue&type=template&id=bc553c46"
import script from "./SelectDepartmentView.vue?vue&type=script&lang=js"
export * from "./SelectDepartmentView.vue?vue&type=script&lang=js"
import style0 from "./SelectDepartmentView.vue?vue&type=style&index=0&id=bc553c46&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports